import { SVGProps, Ref, forwardRef } from 'react';

export const CrossCircleFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 .5C2.375.5.5 4.25.5 8s1.875 7.5 7.5 7.5 7.5-3.75 7.5-7.5S13.625.5 8 .5M5.827 11.16l2.171-2.172 2.171 2.171.99-.99L8.988 8l2.171-2.172-.99-.99-2.171 2.171-2.171-2.17-.99.99 2.171 2.17-2.171 2.171z"
                fill="currentColor"
            />
        </g>
    </svg>
));
CrossCircleFilledSize16Glyph.displayName = 'CrossCircleFilledSize16Glyph';
